var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.992 15.45 3.85 10.675l-1.35 1.05 7.5 5.833 7.5-5.833-1.358-1.059-6.15 4.784zM10 13.333l6.133-4.775L17.5 7.5 10 1.667 2.5 7.5l1.358 1.058L10 13.333z"
})));
export default SvgLayers;